import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';
import { getCurrentReport } from '../../../user/redux/selectors/UserReportSelectors';
import { getSelectionCriteria } from '../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors';
import { reportLoadData, updateReportCustomFilter, reportClearData } from '../redux/actions/ReportsActions';
import { getReportCustomFilter } from '../redux/selectors/ReportsSelectors';
import SelectionCriteriaDto from '../models/SelectionCriteriaDto';
import ReportDefinitions from '../../../common/config/ReportDefinitions';

class ReportCustomFiltersEdiExchange706 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allOrigin: this.props.customFilter.allOrigin,
      allDestination: this.props.customFilter.allDestination,
    };
  }

  onShowAllSelect = (selected) => {
    this.loadReport({
      ...this.state,
      allOrigin: selected.indexOf('allOrigin') > -1,
      allDestination: selected.indexOf('allDestination') > -1,
    });
  };

  getSelecedShowAll = () => {
    const selected = [];
    if (this.state.allOrigin) selected.push('allOrigin');
    if (this.state.allDestination) selected.push('allDestination');
    return selected;
  };

  loadReport = (state) => {
    const { reportCode } = this.props.currentReport;
    const report = ReportDefinitions[reportCode];
    // his.props.reportClearData('EDI_EXCHANGE_PARCEL_706');
    // this.props.reportClearData('EDI_EXCHANGE_EMS_706');
    // this.props.reportClearData('EDI_EXCHANGE_LETTER_706');
    this.props.updateReportCustomFilter(state);
    const selectionCriteria =
      new SelectionCriteriaDto(this.props.selectionCriteria, report.selectionCriteria.items);
    this.props.reportLoadData(report, reportCode, {
      ...selectionCriteria,
      ...state,
    });
    this.setState(state);
  };

  render() {
    return (
      <div className="custom-filter-list">
        <div className="checkbox-group-tree">
          <CheckboxTreeSelector
            nodes={[
              {
                value: 'allOrigin',
                label: 'Show all messages regardless of origin',
              },
              {
                value: 'allDestination',
                label: 'Show all messages regardless of destination',
              },
            ]}
            selected={this.getSelecedShowAll()}
            onSelect={this.onShowAllSelect}
            expandDisabled
            allSelectorDisabled
          />
        </div>

        <div className="legend-group">
          <div className="legend">
            <div className="legend-color bg-green-2" />
            <div className="legend-text">Predes 2.1</div>
          </div>
          <div className="legend">
            <div className="legend-color bg-red-2" />
            <div className="legend-text">Predes 2.0</div>
          </div>
          <div className="legend">
            <div className="legend-color bg-orange-1" />
            <div className="legend-text">Both</div>
          </div>
        </div>
      </div>
    );
  }
}

ReportCustomFiltersEdiExchange706.propTypes = {
  currentReport: PropTypes.objectOf(PropTypes.shape),
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  customFilter: PropTypes.objectOf(PropTypes.shape),
  reportLoadData: PropTypes.func,
  updateReportCustomFilter: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  reportClearData: PropTypes.func,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    reportLoadData,
    updateReportCustomFilter,
    reportClearData,
  }, dispatch);

const mapStateToProps = state => ({
  currentReport: getCurrentReport(state),
  selectionCriteria: getSelectionCriteria(state),
  customFilter: getReportCustomFilter(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportCustomFiltersEdiExchange706);
